import { JsonPipe } from "@angular/common";
import { Component, Input } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { Dialog } from "primeng/dialog";
import { SafeHtmlPipe } from "../../pipes/safe-html.pipe";
import { TranslateModelPipe } from "../../pipes/translate-model.pipe";
import { CodeHighlightComponent } from "../code-highlight/code-highlight.component";
import { DialogComponentBase } from "../dialog/dialog.component";

export enum TextDisplayType {
    Text = 0,
    Code = 1,
    Json = 2,
    DomainTranslation = 3,
}

@Component({
    selector: "app-text-dialog",
    templateUrl: "./text.dialog.html",
    imports: [TranslateModelPipe, SafeHtmlPipe, CodeHighlightComponent, JsonPipe, TranslateModule, Dialog],
})
export class TextDialogComponent extends DialogComponentBase {
    @Input() autoWidth = false;

    title: string;
    data: any;
    type: TextDisplayType;
    callback?: () => void;

    constructor(readonly translate: TranslateService) {
        super();
    }

    open(title: string, data: {} | string, type: TextDisplayType = TextDisplayType.Text, onClose?: () => void) {
        this.title = title;
        this.data = data;
        this.type = type;
        this.callback = onClose;
        this.openDialog();
    }

    protected override onClose() {
        if (this.callback) {
            this.callback();
        }

        this.data = null;
    }
}
